import React from 'react'
import { useDispatch } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import StandardModalContent from 'GeneralUI/StandardModalContent/StandardModalContent.jsx'
import { closeModal } from 'actions/modalActions'
import { xtractAPI } from 'actions/apiActions'
import { clearNotification } from 'actions/notificationActions'
import { setScreenContext } from 'actions/interactableActions'

const InsecurePasswordModal = ({ notification }) => {
  const dispatch = useDispatch()
  const breachesContent = (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <p style={{ textAlign: 'left', fontSize: '1.2em' }}>
        {notification.body}
      </p>
      <FontAwesomeIcon
        icon={['fas', 'shield-check']}
        style={{
          alignSelf: 'center',
          fontSize: '50px',
          color: 'var(--red-color)'
        }}
        aria-hidden="true"
      />
      <p style={{ textAlign: 'left', fontSize: '1.4em' }}>
        {'This does '}
        <b>{'NOT'}</b>
        {' mean than your system has been breached!'}
      </p>
      <p style={{ textAlign: 'left', fontSize: '1.2em' }}>
        {
          'Please change this password as soon as possible. \nXtract Solutions values your security and uses the service '
        }
        <a target="_blank" href="https://haveibeenpwned.com" className="link">
          {'Have I Been Pwned?'}
        </a>
        {
          ' to actively check passwords against thousands of known security threats, like those you see in the news. This password is susceptible to a security threat and should be updated promptly. \nTo update your password, go to User details and change your password.'
        }
      </p>
    </div>
  )

  const closeHandler = () => {
    dispatch(clearNotification(notification))
    dispatch(
      xtractAPI(
        `me/notification/${notification.notification_id}`,
        'delete',
        {
          notification_id: notification.notification_id,
          read_at: true
        },
        {
          200: () => {
            dispatch(closeModal(notification.subject.replace(' ', '_')))
            dispatch(
              setScreenContext('nurseDashboard', [{ ref: 'userDetails' }])
            )
          },
          404: () => {
            dispatch(closeModal(notification.subject.replace(' ', '_')))
            dispatch(
              setScreenContext('nurseDashboard', [{ ref: 'userDetails' }])
            )
          } //if its not there anymore we dont need to worry about deleting it
        }
      )
    )
  }

  return (
    <StandardModalContent
      messageContent={breachesContent}
      cancelHandler={closeHandler}
      cancelText={'OK'}
      closeSelf={closeHandler}
    />
  )
}

export default InsecurePasswordModal
